import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './image-card.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class ImageCard extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * XS and LG images object.
       * @type {{src: string, altText: string}}
       */
      image: { type: Object },
      /**
       * Main content area title
       */
      heading: { type: String },
      /**
       * Main content area title color
       */
      headingColor: { type: String },
      /**
       * Main content area text below heading
       */
      link: { type: Object },
      /**
       * Button url
       */
      bodytext: { type: String },
      styleclass: { type: String },
      iconName: { type: String },
      columns: { type:String }
    }
  }

  constructor() {
    super()
    this.bodytext = ''
    this.styleclass = ''
    this.image = {}
    this.iconName = 'arrow-right'
    this.columns = ''
  }

  render() {
    return html`
      <div
        class="${classMap({
          'cta-card': true,
          'cta-card--has-image': this.image && this.image.src,
          [`cta-card--${this.styleclass}`]: !!this.styleclass,
          'cta-card--with-url': !!this.link.url,
        })}"
      >
        <hf-link
          class="cta-card__wrapper"
          href="${this.link.url}"
          target="${this.link.target}"
          ignoreExternalUrl
          styleclass="cta-card"
        >
          ${this.image && this.image.src
            ? html` <div class="cta-card__image">
                <hf-image
                  src="${this.image.src}"
                  alt="${this.image.alt}"
                  imageSize="full"
                  styleOverride="image-style-size-cta-card ${this.columns == 1 ? 'image_full-height' : ''}"
                ></hf-image
              ></div>`
            : nothing}
          ${this.heading
            ? html`<hf-heading level="2" levelStyle="heading4" class="cta-card__title" color="${this.headingColor}">
              ${this.heading}
            </hf-heading>`
            : ''}
          ${this.bodytext.length
            ? html`
                <hf-paragraph
                  class="cta-card__body-text"
                  styleclass=${this.styleclass ? this.styleclass : 'cta-card'}
                  >${this.bodytext}</hf-paragraph
                >
              `
            : nothing}
          ${this.link.text && this.link.url
            ? html`
          <div class="cta-card__link">
            <span class="cta-card__link-text">
              ${this.link.text}
            </span>
            <span class="cta-card__link-icon">
              <hf-icon name="${this.iconName}" class="btn__icon"></hf-icon>
            </span>
          </div>
        `
        : ''}

        </hf-link>
      </div>
    `
  }
}

customElements.define('hf-image-card', ImageCard)
